import { render, staticRenderFns } from "./YardNotificationDocumentTable.vue?vue&type=template&id=dc77a3dc&"
import script from "./YardNotificationDocumentTable.vue?vue&type=script&lang=js&"
export * from "./YardNotificationDocumentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports